// Catches a visitor Shopify has dropped on the wrong page after they submitted
// the calculator.
//
// The sequence, observed on the live shop: the enquiry is submitted, Shopify's
// spam protection shows its "prove you are not a robot" page, the visitor
// solves it — and Shopify then processes the enquiry and redirects to the shop's
// ROOT rather than back to the calculator. The URL it lands on says
// `/?contact_posted=true#CalculatorForm`: the enquiry went through, and the
// destination was lost.
//
// Nothing in the theme can change where Shopify sends that redirect, so this
// reads the signature and finishes the journey. It is a safety net, not the
// fix — the fix is Shopify's spam protection not firing, which is a setting in
// Admin under Online Store → Preferences.
//
// A plain `defer` script rather than a module, and loaded on every page, because
// the page it has to run on is whichever one Shopify chose — usually the front
// page, which loads none of the calculator's own code. `defer` also keeps
// theme-check's ParserBlockingScript happy.

(function () {
  'use strict';

  // Must match tank-calculator.js. Kept as a literal rather than shared,
  // because a relative import between two theme assets loses the `?v=`
  // fingerprint and is then cached for a year with nothing able to bust it.
  var STORAGE_KEY = 'brugregnvand:beregner';

  // The anchor is what makes this specific to the calculator. The footer's
  // newsletter form also posts to /contact and can come back with
  // `contact_posted=true`, but its anchor is `#NewsletterForm`.
  var ANCHOR = '#CalculatorForm';

  function run() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('contact_posted') !== 'true') return;
      if (window.location.hash !== ANCHOR) return;

      // Already where we want to be: the calculator page renders its own
      // confirmation, so leave it alone. This is also what stops a redirect
      // loop, together with the target URL carrying no `contact_posted`.
      if (document.querySelector('tank-calculator')) return;

      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      var parsed = JSON.parse(raw);
      var url = parsed && parsed.values && parsed.values.returnUrl;
      if (typeof url !== 'string' || !url) return;

      // Same-origin only. The URL is written by our own code, but it ends up in
      // storage, which anything running on this domain can write to — so it is
      // treated as input rather than trusted.
      var target = new URL(url, window.location.origin);
      if (target.origin !== window.location.origin) return;

      // `replace`, not `assign`: the page Shopify chose should not sit in the
      // history for Back to return to.
      window.location.replace(target.toString());
    } catch (error) {
      // Any failure leaves the visitor on the page Shopify chose, which is what
      // would have happened anyway. Never worth an error on screen.
    }
  }

  // The element check needs a parsed body, and `defer` guarantees that.
  run();
})();
